'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function isDOMEvent(event) {
  if ((typeof event === 'undefined' ? 'undefined' : _typeof(event)) !== 'object') return false;
  if (event.target instanceof HTMLElement) return true;
  return false;
}

exports.default = isDOMEvent;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/isDOMEvent.js
// module id = 1679
// module chunks = 0